export const getters = {
    children: state => state.children && state.children.map(child => ({ ...child, picture: child.picture || require('@/assets/img/svg/default-user-logo.svg') })) || [],
    childId: state => state.childId,
    childInfo: state => state.childInfo,
    childScheduleInfo: state => state.childScheduleInfo,
    childPhoto: state => state.childPhoto,
    childInfoForEdit: state => state.childInfoForEdit
};


// WEBPACK FOOTER //
// ./src/store/modules/children/getters.js